<template>
	<div class="flex-box" :style="style">
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		justify: String,
		align: String,
		flexWrap: String,
		gap: String,
		direction: String
	},
	// setup(props, { emit, slots, attrs }) {},
	data() {
		return {}
	},
	computed: {
		style() {
			const { justify, align, flexWrap, gap, direction } = this
			return {
				justifyContent: justify,
				alignItems: align,
				flexWrap,
				gap,
				flexDirection: direction
			}
		}
	},
	mounted() {},
	methods: {},
	components: {}
}
</script>

<style lang="scss" scoped="scoped">
.flex-box {
	display: flex;
}
</style>
